<div class="formfield">
    <div [formGroup]="userForm">
      <nes-select
      [label]="'USER_DATA.INPUT.COUNTRY.LABEL' | translate"
      [name]="'USER_DATA.INPUT.COUNTRY.NAME' | translate"
      [cypress]="'country'"
      [value]="selectedCountryCode"
      [options]="countries"
      ngDefaultControl
      nesFormControl
      controlled
      required
      nes-id="country"
        (nesOnChange)="selected.emit($event.detail.value)"
      >
      </nes-select>
    </div>
  </div>